module.exports = __webpack_public_path__ + "static/media/appstore-2e.4c819348.png";